import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import CountdownDialog from "../../components/InactivityDialog/CountdownDialouge";

/**
 *
 * @param {*} debugMode - Show Status and idle timeout
 * @param {*} inactivityThresholdMS - Time allowed for user to be inactive
 * @param {*} warningInMS - Warning in must be lesser than Max Inactivity Time (Show countdown...) [Atleast 20000ms Difference]
 * @param {*} timeoutCallback - If timeout/logout clicked
 * @returns
 */
const CustomIdleTimer = (props) => {
  const {
    debugMode,
    disabled,
    timeoutCallback,
    warningInMS,
    inactivityThresholdMS,
  } = props;

  const [state, setState] = useState("Active");
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);

  const onIdle = () => {
    setState("Idle");
    callTimeout();
  };

  const onActive = () => {
    setOpenDialog(false);
    setState("Active");
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const onPrompt = () => {
    setOpenDialog(true);
  };

  const onReset = () => {
    reset();
    if (state !== "Active") setState("Active");
  };

  const { getRemainingTime, start, pause, reset, resume, isIdle } =
    useIdleTimer({
      onIdle,
      promptTimeout: warningInMS - 1000, // 1000 : Buffer for on prompt..
      onPrompt,
      onActive,
      onAction,
      timeout: inactivityThresholdMS - warningInMS - 1000, // 1000 : Buffer for on prompt..
      throttle: 500,
    });

  useEffect(() => {
    start();
  }, [disabled]);

  async function callTimeout() {
    setOpenDialog(false);
    setState("Idle");
    setRemaining(1);
    timeoutCallback();
  }

  useEffect(() => {
    if (!disabled) {
      resume();
      if (openDialog && remaining * 1000 > warningInMS) {
        setOpenDialog(false);
      }
      const interval = setInterval(() => {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }, 500);
      return () => {
        clearInterval(interval);
      };
    } else {
      pause();
    }
  });

  return (
    <>
      {debugMode && (
        <>
          <br />
          <div>Current State: {state}</div>
          <div>Action Events: {count}</div>
          <p>{remaining} seconds remaining</p>
        </>
      )}
      <CountdownDialog
        open={openDialog}
        setOpen={setOpenDialog}
        count={remaining}
        handleLogout={async () => {
          await callTimeout();
        }}
        onClose={() => {
          setOpenDialog(false);
          onReset();
        }}
      />
    </>
  );
};

export default CustomIdleTimer;

CustomIdleTimer.defaultProps = {
  disabled: false,
  debugMode: false,
  timeoutCallback: () => {
    console.log("Timeout");
  },
  warningInMS: 50000,
  inactivityThresholdMS: 60000,
};
